/* ══════════════════════════════════════════════════════════════════════
   DDR → BOTTLER (and bottler unit) mapping, from the refreshed DDR list.
   Keys are the legacy DDR names ("UP-6", "AP-Hyderabad UA"); the workbook
   uses current names ("UttarPradesh-6", "HYDERABAD"), so lookups go through
   the same resolver the map uses. Where a DDR appeared under more than one
   bottler, the majority bottler is kept.
   ══════════════════════════════════════════════════════════════════════ */
import { buildGeoIndex, resolveDdrToGeo, normalizeDdr } from "./Ddrnames";

export const DDR_BOTTLER_RAW = {
  "AP-1": ["HCCB", "HCCB_AP"],
  "AP-2": ["HCCB", "HCCB_AP"],
  "AP-3": ["HCCB", "HCCB_AP"],
  "AP-4": ["Sri Sarvaraya - Rajahmundry", "Sri Sarvaraya - Rajahmundry"],
  "AP-Hyderabad UA": ["HCCB", "HCCB_TLG"],
  "AP-Visakhapatnam UA": ["HCCB", "HCCB_AP"],
  "AP-Vijayawada UA": ["HCCB", "HCCB_AP"],
  "Assam-1": ["Moon Beverages", "Moon- NER"],
  "Assam-2": ["Moon Beverages", "Moon- NER"],
  "Assam-3": ["Moon Beverages", "Moon- NER"],
  "Assam-4": ["Moon Beverages", "Moon- NER"],
  "Assam-5": ["Moon Beverages", "Moon- NER"],
  "UP-Agra UA": ["SLMG", "Central UP"],
  "UP-Allahabad UA": ["SLMG", "East UP-2"],
  "Bihar-1": ["SLMG", "SLMG-Bihar"],
  "Bihar-2": ["SLMG", "SLMG-Bihar"],
  "Bihar-3": ["SLMG", "SLMG-Bihar"],
  "Bihar-4": ["SLMG", "SLMG-Bihar"],
  "Bihar-5": ["SLMG", "SLMG-Bihar"],
  "Bihar-6": ["SLMG", "East UP-1"],
  "Bihar-7": ["SLMG", "SLMG-Bihar"],
  "Bihar-8": ["SLMG", "SLMG-Bihar"],
  "Gujarat-3": ["Kandhari Beverages Pvt. Ltd.", "KGB Gujarat"],
  "Gujarat-4": ["HCCB", "HCCB_GUJ"],
  "Pun-Chandigarh UA": ["Kandhari Beverages Pvt. Ltd.", "KGB KBPL"],
  "Pun-2": ["Ludhiana Beverages", "Ludhiana Beverages"],
  "Chhattisgarh-1": ["Superior", "Superior"],
  "Chhattisgarh-2": ["Superior", "Superior"],
  "Chhattisgarh-3": ["Superior", "Superior"],
  "Durg-Bhilainagar UA": ["Superior", "Superior"],
  "Raipur": ["Superior", "Superior"],
  "Delhi-Delhi UA": ["Enrich + Moon", "Enrich + Moon"],
  "Mah-Nagpur UA": ["Superior", "Superior"],
  "FBO SLMG": ["SLMG", "Central UP"],
  "Mah-1": ["Superior", "Superior"],
  "MP-1": ["Superior", "Superior"],
  "Goa-1": ["HCCB", "HCCB_KKG"],
  "Gujarat-Ahmedabad UA": ["Kandhari Beverages Pvt. Ltd.", "KGB Gujarat"],
  "Gujarat-Rajkot UA": ["Kandhari Beverages Pvt. Ltd.", "KGB Gujarat"],
  "Gujarat-Surat UA": ["HCCB", "HCCB_GUJ"],
  "Gujarat-Vadodara UA": ["HCCB", "HCCB_GUJ"],
  "Haryana-1": ["Kandhari Beverages Pvt. Ltd.", "KGB KBPL"],
  "Haryana-Faridabad": ["Kandhari Beverages Pvt. Ltd.", "KGB Enrich"],
  "Haryana-3": ["Kandhari Beverages Pvt. Ltd.", "KGB KBPL"],
  "Haryana-2": ["Kandhari Beverages Pvt. Ltd.", "KGB KBPL"],
  "Haryana-Gurgaon UA": ["Kandhari Beverages Pvt. Ltd.", "KGB Enrich"],
  "HimachalPradesh-1": ["Kandhari Beverages Pvt. Ltd.", "KGB KBPL"],
  "HimachalPradesh-2": ["Waves Beverages", "Waves Beverages"],
  "Jammu_&_Kashmir-1": ["Kandhari Beverages Pvt. Ltd.", "KGB KBPL"],
  "Jharkhand-1": ["Moon Beverages", "Moon- NER"],
  "Jharkhand-2": ["Moon Beverages", "Moon- NER"],
  "Jharkhand-3": ["Moon Beverages", "Moon- NER"],
  "Jharkhand-4": ["Moon Beverages", "Moon- NER"],
  "Jharkhand-Ranchi UA": ["Moon Beverages", "Moon- NER"],
  "Jharkhand-Dhanbad UA": ["Moon Beverages", "Moon- NER"],
  "Jharkhand-Jamshedpur UA": ["Moon Beverages", "Moon- NER"],
  "Karnataka-1": ["HCCB", "HCCB_KKG"],
  "Karnataka-2": ["HCCB", "HCCB_KKG"],
  "Karnataka-3": ["HCCB", "HCCB_KKG"],
  "Karnataka-4": ["HCCB", "HCCB_KKG"],
  "Karnataka-5": ["HCCB", "HCCB_KKG"],
  "Karnataka-6": ["HCCB", "HCCB_KKG"],
  "Karnataka-Bangalore UA": ["HCCB", "HCCB_KKG"],
  "Kerala-1": ["HCCB", "HCCB_KKG"],
  "Kerala-2": ["HCCB", "HCCB_KKG"],
  "Kerala-3": ["HCCB", "HCCB_KKG"],
  "Kerala-Kochi UA": ["HCCB", "HCCB_KKG"],
  "Gujarat-1": ["Kandhari Beverages Pvt. Ltd.", "KGB Gujarat"],
  "MP-2": ["HCCB", "HCCB_MP"],
  "MP-3": ["HCCB", "HCCB_MP"],
  "MP-4": ["HCCB", "HCCB_MP"],
  "MP-5": ["HCCB", "HCCB_MP"],
  "MP-Bhopal UA": ["HCCB", "HCCB_MP"],
  "MP-Indore UA": ["HCCB", "HCCB_MP"],
  "Jabalpur": ["Superior", "Superior"],
  "Mah-Greater Mumbai UA": ["HCCB", "HCCB_Mah"],
  "Mah-Nashik UA": ["HCCB", "HCCB_Mah"],
  "Mah-Pune UA": ["HCCB", "HCCB_Mah"],
  "Mah-7": ["HCCB", "HCCB_Mah"],
  "Mah-3": ["HCCB", "HCCB_Mah"],
  "Mah-4": ["HCCB", "HCCB_Mah"],
  "Mah-5": ["HCCB", "HCCB_Mah"],
  "Mah-6": ["HCCB", "HCCB_Mah"],
  "NorthEast-1": ["Moon Beverages", "Moon- NER"],
  "NorthEast-2": ["Moon Beverages", "Moon- NER"],
  "NorthEast-3": ["Moon Beverages", "Moon- NER"],
  "NorthEast-4": ["Moon Beverages", "Moon- NER"],
  "NorthEast-5": ["Moon Beverages", "Moon- NER"],
  "NorthEast-6": ["Moon Beverages", "Moon- NER"],
  "NorthEast-7": ["Moon Beverages", "Moon- NER"],
  "Orissa-4": ["HCCB", "HCCB_East"],
  "Orissa-2": ["HCCB", "HCCB_East"],
  "Orissa-3": ["HCCB", "HCCB_East"],
  "Orissa-1": ["HCCB", "HCCB_East"],
  "Orissa-5": ["HCCB", "HCCB_East"],
  "Pondicherry-1": ["HCCB", "HCCB_TN"],
  "Pun-1": ["Kandhari Beverages Pvt. Ltd.", "KGB KBPL"],
  "Pun-Ludhiana": ["Ludhiana Beverages", "Ludhiana Beverages"],
  "Pun-3": ["Waves Beverages", "Waves Beverages"],
  "Pun-Amritsar UA": ["Waves Beverages", "Waves Beverages"],
  "Rajasthan-1": ["Kandhari Beverages Pvt. Ltd.", "KGB Rajasthan"],
  "Rajasthan-2": ["Kandhari Beverages Pvt. Ltd.", "KGB Rajasthan"],
  "Kota (M CORP.)": ["Kandhari Beverages Pvt. Ltd.", "KGB Rajasthan"],
  "Rajasthan-3": ["Kandhari Beverages Pvt. Ltd.", "KGB Rajasthan"],
  "Rajasthan-4": ["Kandhari Beverages Pvt. Ltd.", "KGB Rajasthan"],
  "Rajasthan-5": ["Kandhari Beverages Pvt. Ltd.", "KGB Rajasthan"],
  "Jodhpur UA": ["Kandhari Beverages Pvt. Ltd.", "KGB Rajasthan"],
  "Rajasthan-6": ["Kandhari Beverages Pvt. Ltd.", "KGB Rajasthan"],
  "Jaipur": ["Kandhari Beverages Pvt. Ltd.", "KGB Rajasthan"],
  "Gujarat-2": ["Kandhari Beverages Pvt. Ltd.", "KGB Gujarat"],
  "Gujarat-5": ["HCCB", "HCCB_GUJ"],
  "Gujarat-6": ["HCCB", "HCCB_GUJ"],
  "TN-1": ["HCCB", "HCCB_TN"],
  "TN-2": ["HCCB", "HCCB_TN"],
  "TN-3": ["HCCB", "HCCB_TN"],
  "TN-4": ["HCCB", "HCCB_TN"],
  "TN-5": ["HCCB", "HCCB_TN"],
  "TN-6": ["HCCB", "HCCB_TN"],
  "TN-Chennai UA": ["HCCB", "HCCB_TN"],
  "TN-Coimbatore": ["HCCB", "HCCB_TN"],
  "TN-Madurai UA": ["HCCB", "HCCB_TN"],
  "Gwalior": ["SLMG", "Central UP"],
  "UP-Kanpur UA": ["SLMG", "Central UP"],
  "UP-Lucknow UA": ["SLMG", "Central UP"],
  "Bihar-Patna UA": ["SLMG", "SLMG-Bihar"],
  "UP-1": ["SLMG", "Central UP"],
  "UP-10": ["SLMG", "West UP"],
  "UP-3": ["SLMG", "East UP-1"],
  "UP-4": ["SLMG", "West UP"],
  "UP-5": ["SLMG", "East UP-1"],
  "UP-6": ["SLMG", "Central UP"],
  "UP-7": ["SLMG", "Central UP"],
  "UP-8": ["SLMG", "East UP-2"],
  "UP-9": ["SLMG", "East UP-2"],
  "Uttarakhand-1": ["SLMG", "West UP"],
  "Uttarakhand-2": ["SLMG", "West UP"],
  "UP-11": ["Moon Beverages", "Moon- NCR"],
  "Uttarakhand-3": ["SLMG", "West UP"],
  "UP-Meerut UA": ["Moon Beverages", "Moon- NCR"],
  "UP-Varanasi UA": ["SLMG", "East UP-2"],
  "UP-Noida": ["Moon Beverages", "Moon- NCR"],
  "WB-3": ["Moon Beverages", "Moon- NER"],
  "WB-4": ["Moon Beverages", "Moon- NER"],
  "WB-2": ["Bengal Beverages - Dankuni", "Bengal Beverages - Dankuni"],
  "WB-1": ["Bengal Beverages - Dankuni", "Bengal Beverages - Dankuni"],
  "WB-Kolkata UA": ["Diamond Beverages - Taratala", "Diamond Beverages - Taratala"],
  "Asansole": ["Moon Beverages", "Moon- NER"],
};

/* States whose DDRs are blank in the source list but belong to one unit */
const STATE_FALLBACK = { "Telangana": ["HCCB", "HCCB_TLG"] };

const INDEX = buildGeoIndex(Object.keys(DDR_BOTTLER_RAW));

/** Workbook DDR name → { bottler, unit } (null when unmapped). */
export function bottlerOfDdr(ddr, state) {
  if (!ddr) return null;
  const direct = DDR_BOTTLER_RAW[ddr];
  let hit = direct;
  if (!hit) {
    const k = normalizeDdr(ddr);
    const exact = INDEX.byKey.get(k);
    if (exact) hit = DDR_BOTTLER_RAW[exact];
  }
  if (!hit) {
    const geos = resolveDdrToGeo(ddr, INDEX);
    if (geos.length) {
      // majority across the matched legacy DDRs
      const c = {};
      geos.forEach(g => { const b = DDR_BOTTLER_RAW[g]; if (b) c[b[0]] = (c[b[0]] || 0) + 1; });
      const best = Object.entries(c).sort((a, b) => b[1] - a[1])[0]?.[0];
      hit = best ? geos.map(g => DDR_BOTTLER_RAW[g]).find(b => b && b[0] === best) : null;
    }
  }
  if (!hit && state && STATE_FALLBACK[state]) hit = STATE_FALLBACK[state];
  return hit ? { bottler: hit[0], unit: hit[1] } : null;
}